import { useState } from "react";

const STORAGE_PREFIX = "mmx-admin-pagination-size:";

function storageKey(tableKey: string) {
  return `${STORAGE_PREFIX}${tableKey}`;
}

function readStoredPageSize(tableKey: string): number | null {
  if (typeof localStorage === "undefined") return null;
  const stored = localStorage.getItem(storageKey(tableKey));
  if (!stored) return null;
  const value = parseInt(stored, 10);
  return isNaN(value) ? null : value;
}

/** The user's last explicitly selected page size for this table, or null if they've never picked one. */
export function usePersistedPageSize(tableKey: string) {
  const [storedPageSize, setStoredPageSize] = useState<number | null>(() => readStoredPageSize(tableKey));

  const persist = (size: number) => {
    setStoredPageSize(size);
    if (typeof localStorage !== "undefined") {
      localStorage.setItem(storageKey(tableKey), String(size));
    }
  };

  const clear = () => {
    setStoredPageSize(null);
    if (typeof localStorage !== "undefined") {
      localStorage.removeItem(storageKey(tableKey));
    }
  };

  return { storedPageSize, persist, clear };
}
